import React from 'react';
import PropTypes from 'prop-types';
import './Counter.scss';

const Counter = ({ count, onMenu, }) => (
  <span className={['ui-counter', (onMenu ? 'ui-counter--on-menu' : '')].join(' ')}>
    { count }
  </span>
);

Counter.propTypes = {
  count: PropTypes.number.isRequired,
  onMenu: PropTypes.bool,
};

Counter.defaultProps = {
  count: '',
  onMenu: false,
};

export default Counter;
